import { Box } from 'components/ui/Box'
import { Paper } from 'components/ui/Paper'
import { Typography } from 'components/ui/Typography'
import styled from 'styled-components'
import { pageWrapper } from 'styles/mixins/page'

export const Wrapper = styled.div`
  ${pageWrapper(false)}

  span {
    line-height: 1.3;
  }
`

export const ContentWrapper = styled.div`
  max-width: 1140px;
  margin-top: 24px;
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 865px) {
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
`

export const ContentItem = styled.div`
  &:first-child {
    @media screen and (max-width: 865px) {
      order: 2;
    }
  }
`

export const RuleBox = styled(Box)`
  @media screen and (max-width: 865px) {
    margin: 16px 0;
  }
`

export const StyledListItem = styled(Typography)`
  color: #99c7ff;
  font-size: 18px;
  font-weight: bold;
`

export const Card = styled.div`
  box-shadow: 0 0 20px rgba(19, 114, 255, 0.15);
  border-radius: 12px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.core.WHITE};
`

export const CardContentPaper = styled(Paper)`
  padding: 32px;

  @media screen and (max-width: 590px) {
    padding: 16px;
  }
`

export const CardBg = styled.div`
  position: relative;
  width: 100%;
  height: 125px;
  @media screen and (max-width: 865px) {
    height: 200px;
  }

  @media screen and (max-width: 615px) {
    height: 125px;
  }
`
